import emitter from "tiny-emitter/instance";

export const bus = {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
};

export default ({ app }) => {
  // eslint-disable-next-line no-param-reassign
  app.config.globalProperties.$emitter = bus;
};
